<div class="chart-content" #chartContainer>
  <svg #chartSvg></svg>
  <div class="chart-tooltip" #tooltip></div>
  <!-- Centered overlay when the current x-window contains no data points —
  e.g. user picked a 1W preset but backups only started yesterday. -->
  @if (!hasVisibleData) {
    <div class="chart-empty-overlay">{{ noDataMessage }}</div>
  }
  <!-- Time range presets — zoom the x-axis to a fixed window -->
  <div class="time-range-buttons" role="group" aria-label="Chart time range">
    <button
      type="button"
      class="time-range-btn"
      [class.active]="activeRange === '1d'"
      [attr.aria-pressed]="activeRange === '1d'"
      (click)="setTimeRange('1d')"
    >
      1D
    </button>
    <button
      type="button"
      class="time-range-btn"
      [class.active]="activeRange === '3d'"
      [attr.aria-pressed]="activeRange === '3d'"
      (click)="setTimeRange('3d')"
    >
      3D
    </button>
    <button
      type="button"
      class="time-range-btn"
      [class.active]="activeRange === '1w'"
      [attr.aria-pressed]="activeRange === '1w'"
      (click)="setTimeRange('1w')"
    >
      1W
    </button>
    <button
      type="button"
      class="time-range-btn"
      [class.active]="activeRange === '2w'"
      [attr.aria-pressed]="activeRange === '2w'"
      (click)="setTimeRange('2w')"
    >
      2W
    </button>
  </div>
</div>
